export default "__VITE_ASSET__DPhcJEQK__"